import { FC } from "react";
import { FiltersBar, SortersBar } from "../components";
import { useJourneyListingContext } from "../context/JourneyListingContext";
import { JourneyType, DataGroupType } from "src/Modules/Flights/constants";
import JourneyListContent from "../components/JourneyList/components/JourneyListContent/JourneyListContent";
import {MainSearch} from "src/Modules/Flights/Components";
import classNames from "classnames";
import CountdownTimerSlider from "@Components/CountdownTimerSlider/CountdownTimerSlider";
const JourneyListingWeb: FC<{
  fullDataGroups: DataGroupType;
  filteredGroups: DataGroupType;
  journies: JourneyType[];
}> = ({
  fullDataGroups,
  filteredGroups,
  journies,
}) => {
  const { isFetching, searchObject } = useJourneyListingContext();
  const hasJournies = isFetching || journies.length > 0;
  return (
    <div className="flex flex-col bg-background-default">
      <div className="p-3 xl:px-10 lg:px-4 shadow-md bg-background-default">
        <MainSearch initialValues={searchObject} />
      </div>
      <div className="sticky top-0 z-30">
        <CountdownTimerSlider/>
      </div>
      <div className="flex gap-1 xl:gap-4 xl:px-10 lg:px-4">
        <div className={classNames("min-w-75 flex-1","custom-scrollbar")}>
          <div className={"sticky top-5 overflow-y-auto max-h-screen "}>
            <FiltersBar dataGroups={fullDataGroups} />
          </div>
        </div>
        <div className="flex-4 min-w-170 flex flex-col gap-6 p-4">
          {hasJournies && (
            <div className="sticky top-8 bg-background-default z-10">
              <SortersBar dataGroups={filteredGroups} />
            </div>
          )}
          <div>
            <JourneyListContent isFetching={isFetching} journies={journies}/>
          </div>
        </div>
        <div className="flex-1"></div>
      </div>
    </div>
  );
};

export default JourneyListingWeb;
